<script>
import Debug from '@/components/meta/Debug'

export default {
  name: 'ViewDebug',

  components: {
    Debug
  }
}
</script>

<template>
  <div class="c-view-debug">
    <debug />
  </div>
</template>

<style lang="scss">

.c-view-debug {
  @include buffer-vertical;
}

</style>
